'use client';

import type { ReactNode } from 'react';

import dynamic from 'next/dynamic';

import FooterV2 from '@/features/v2/shared/footer/Footer';

const InfoSection = dynamic(
  () => { return import('@/features/v2/home/components/InfoSection'); },
  {
    loading: () => { return <div className="h-32 bg-default-100 animate-pulse rounded-lg mx-4" />; },
    ssr: false,
  },
);

interface WrapperFooterProps {
  children?: ReactNode;
}

export function WrapperFooter({ children }: WrapperFooterProps) {
  return (
    <>
      <div className="bg-hbackground !font-text pt-3">
        <InfoSection />
        {children}
        <FooterV2 />
      </div>
    </>
  );
}
